'use strict';

function TableRowSeparatorDirective() {
  return {
    restrict: 'A',
    replace: false,
    link: function(scope, element, attrs, controller) {
      if (
        attrs.rowTableSeparatorPrev &&
        attrs.rowTableSeparatorPrev != attrs.rowTableSeparatorCurr
      ) {
        element.addClass('table-row-separator');
      }
    }
  };
}

export default TableRowSeparatorDirective;
